<mat-paginator
  [length]="length"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  [hidePageSize]="hidePageSize"
  (page)="onPageChange($event)"
  showFirstLastButtons
></mat-paginator>
